import React from 'react';
import { Empty, Spin } from 'antd';
import { isEmpty } from 'underscore';
import { ChartBox } from '../../../../ResultPanel/component/ChartBox';
import styles from '../../Layout/AnalyticsLayout.module.scss';
import ErrorDisplay from '../../ErrorDisplay';

interface ExceedanceChartProps {
  exceedanceValuesImage: string;
  exceedanceValuesLinks: string[];
  pointName: string;
  isLoading: boolean;
  error: string;
  isOfflineDataset: boolean;
}

export default function ExceedanceChart({
  exceedanceValuesImage,
  exceedanceValuesLinks,
  isLoading,
  error,
  isOfflineDataset,
}: ExceedanceChartProps) {
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Spin size='large' />
      </div>
    );
  }

  if (isOfflineDataset) {
    return <ErrorDisplay error={error} isOfflineDataset={isOfflineDataset} />;
  }

  return (
    <div id='Analytics-Exceedance-Plot' className={styles.chartPointWrapper}>
      <ChartBox
        key='Exceedance'
        title='Exceedance'
        height={isLoading || !isEmpty(error) ? '50px' : 'auto'}
        plot={
          isLoading ? (
            <div className={styles.spinner}>
              <Spin size='large' />
            </div>
          ) : !isEmpty(error) && !error.includes('Cmems error') ? (
            <div>{error}</div>
          ) : exceedanceValuesImage ? (
            <img
              style={{
                width: '80%',
                objectFit: 'scale-down',
                maxHeight: '65vh',
                display: 'block',
                margin: '0 auto',
              }}
              src={exceedanceValuesImage}
              alt='Exceedance'
            />
          ) : (
            <Empty
              description={
                error.includes('Cmems error')
                  ? 'Layer not available'
                  : 'No data available'
              }
            />
          )
        }
        dataset=''
        showDisclaimer={exceedanceValuesImage ? true : false}
        link={exceedanceValuesLinks}
      />
    </div>
  );
}
